(function(){
  document.addEventListener('DOMContentLoaded', function() {
    // console.log('jsfile');
    let sliderThumbs,
        sliderProductMain;
    // if ( document.querySelector('.slider--thumbs') ) {
    //   sliderThumbs = new Swiper('.slider--thumbs', {
    //     direction: 'vertical',
    //     slidesPerView: 'auto',
    //     spaceBetween: 9,
    //     loop: true,
    //     initialSlide: 1,
    //     navigation: {
    //       nextEl: '.swiper-button-next',
    //       prevEl: '.swiper-button-prev',
    //     },
    //     freeMode: true,
    //   });
    // }

    // window.sizesSlider = function sizesSlider() {
    //   if ( document.querySelector('.js-card-size-slider') ) {
    //     new Swiper('.js-card-size-slider', {
    //       slidesPerView: 'auto',
    //       spaceBetween: 15,
    //       // centeredSlides: true,
    //       loop: false,
    //       // initialSlide: 1,
    //       navigation: {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //       },
    //       // freeMode: true,
    //     });
    //   }
    // }
    // window.sizesSlider();

    
    if ( document.querySelector('.slider--main') ) {
      /*   *-*************************************************************/
      sliderProductMain = new Swiper('.slider--main', {
        spaceBetween: 0,
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: true,
        initialSlide: 0,
        grabCursor: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          type: "progressbar",
          el: ".swiper-pagination",
          clickable: true,
        },
        // thumbs: {
        //   swiper: sliderThumbs,
        // },
        breakpoints: {
          750: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: false,
            initialSlide: 0,
          },
          990: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            centeredSlides: false,
          },
        },
      });
    }
    

    
    /**
     * Code for changing slides in product slide for each variant
     */
    // let productCur = document.querySelector('[data-tb-variants-json]');
    // if (productCur) {
    //   productCur = JSON.parse(productCur.getAttribute('data-tb-variants-json'));
    // }
    
    // function variantImage(val) {
    //   const selectedVariantId = parseInt(val, 10);
    //   const variant = productCur.filter(v => v.id === selectedVariantId);
      
    //   const slickElements = document.querySelectorAll('[data-for-slick]');
    //   if (slickElements.length > 1 && document.querySelector(`[data-for-slick="${variant[0]?.featured_media?.id}"]`)) {
    //     const activeMedia = document.querySelector(`[data-for-slick="${variant[0].featured_media.id}"]`).getAttribute('aria-label');
    //     const numbers = activeMedia.split("/");
    //     const firstNumber = parseInt(numbers[0]);
    //     sliderProductMain.slideTo(firstNumber - 1);
    //     sliderProductMain.slideTo(firstNumber - 1);
    //   }
    // }
    
    // const initialColorVariant = document.querySelector('product-info .product-variant-id');
    // initialColorVariant?.addEventListener('change', function(event) {
    //   const currentVariant = document.querySelector('.product-variant-id');
      
    //   if (currentVariant) {
    //     const selectedVariantId = currentVariant.value;
    //     variantImage(selectedVariantId);
    //   }
    // });
    
    window.initJsSlideProduct = () => {
    let sliderCard = document.querySelectorAll('.slider--card:not(.swiper-initialized)');

    sliderCard.forEach(function(elem, ind){

      const sliderProductMain = new Swiper(elem, {
        slidesPerView: 1,
        //slidesPerView: 'auto',
        spaceBetween: 0,
        /* Card images past the second are rendered with data-src rather than
           src (card-product-var.liquid) and fetched only when swiped to. This
           is the iPhone crash fix: a collection card carries 5.5 images on
           average, up to 10, and every one of them used to decode as the
           shopper scrolled past - 135 MB of decoded image memory after 12
           scrolls of infinite scroll, never released, which is what killed the
           tab. preloadImages must be off or Swiper fetches them all up front
           anyway, defeating the data-src. */
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: true,
        },
        navigation: {
          nextEl: elem.querySelector('.swiper-button-next'),
          prevEl: elem.querySelector('.swiper-button-prev'),
        },
        pagination: {
          type: 'bullets',
          el: elem.querySelector(".swiper-pagination"),
          clickable: true,
        },
        grabCursor: true, // pointer
        //thumbs: {
          //swiper: sliderThumbs, // thumb slider name
        //},
        // breakpoints: {
        //   0: {
        //   },
        //   750: {
            
        //   },
        // },
        on: {
          init: function () {
            if(this.slides.length < 2) {
              this.el.classList.add('disabled');
            }
          }
        },
      });
    });
  }
  window.initJsSlideProduct();
  }, false);
})();
